import { Component, OnInit, HostListener,ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription }   from 'rxjs/Subscription';
import { NgcCookieConsentService } from 'ngx-cookieconsent';
import {BlogService} from 'src/app/Services/Blog.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-main',
  templateUrl: './Main.component.html',
  styleUrls: ['./Main.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class MainComponent implements OnInit {

  currentUrl: any;
  isRtl: any = 'ltr';
  landing_page=true;
  private popupCloseSubscription: Subscription;
  constructor(public router: Router, 
              public ccService: NgcCookieConsentService,
              private blogService:BlogService,
              private titleService: Title
              ) { }

  ngOnInit() {
    this.landing_page=true;
    
    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.currentUrl = event.url;
          this.addRemoveHeaderClass();
          this.addRemoveFooterClass();
        }
      });
    this.currentUrl = this.router.url;
    let url=this.currentUrl.substring(1,5);
    let page=this.currentUrl.substring(6).trim();
    let tag=this.currentUrl.substring(6,9).trim();
    console.log(url)
      if (url=='blog'){
        if ((page!='')&&(tag!='tag')){
            this.getDetails(page);
        }else{this.landing_page=false;}

       }else{
        this.landing_page=false;
        this.addRemoveHeaderClass();
        this.addRemoveFooterClass();
      }


    //cuando presione aceptar o deny en el mensaje de aceptar cookie... entonces lo hago desaparecer
    //pasaba que en la version movil siempre aparecia el cartelito de "politica de cookie"
    this.popupCloseSubscription = this.ccService.popupClose$.subscribe(
      () => {
        // you can use this.ccService.getConfig() to do stuff...
        //(document.querySelector('.cc-revoke') as HTMLElement).style.display = 'none';
        (document.querySelector('.cc-revoke') as HTMLElement).classList.add('cc-display-none')
      });
      

      this.titleService.setTitle('LUMI: O ensino online que se adapta ao seu perfil.');
     
  }


  removeElementsByClass(className){
    var elements = document.getElementsByClassName(className);
    while(elements.length > 0){
        elements[0].parentNode.removeChild(elements[0]);
    }
}

  public getDetails(slug){
    this.blogService.getPublicPostBySlug(slug).then((post) => {
      if (post.data.landing_page){
        this.removeElementsByClass('cc-revoke')
        this.landing_page=true;
      }else{ this.landing_page=false;}

      }).catch((error) => {
      console.log(error);
      // this.authService.logOutWithRedirect();
    
      });
      
     }
 
  /**
    *addRemoveHeaderClass method is used to add or remove class on header.
    */
  addRemoveHeaderClass  () {
    setTimeout(() => {
      if ( ( this.currentUrl != '/session/comingsoon' ) && ( this.currentUrl != '/session/maintenance' ) ) {
        if (this.currentUrl == '/home') {
          document.getElementById('header-sec').className += ' header-transparent';
        } else {
          document.getElementById('header-sec').classList.remove('header-transparent');
        }
      }
    }, 0);
  }

  // addRemoveFooterClass method is used to add or remove classes on footer.
  addRemoveFooterClass () {
    setTimeout(() => {
      if ( (this.currentUrl != '/session/comingsoon') && (this.currentUrl != '/session/maintenance' ) ) {
        if (this.currentUrl == '/home') {
          document.getElementById('footer-wrap').classList.remove('footer-bg');
        } else {
          document.getElementById('footer-wrap').className += ' footer-bg';
        }
      }
    }, 0);
  }

  /**
    * changeDirection method is used to change the direction of layout.
    */
  public changeDirection() {
    if (this.isRtl == 'rtl') {
      this.isRtl = 'ltr';
    } else {
      this.isRtl = 'rtl';
    }
  }

  onActivate ($event) {
    setTimeout(() => {
      window.scroll(0, 0);
    }, 0);
  }

  @HostListener('window:scroll', ['$event'])
  // onScrollEvent method is used to show or hide the sticky header.
  onScrollEvent ($event) {
    if (this.landing_page){return}
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (scrollTop >= 200) {
      if ( !document.getElementById('header-sticky').classList.contains('visible') ) {
        document.getElementById('header-sticky').className += ' visible';
      }
    }  else {
      document.getElementById('header-sticky').classList.remove('visible');
    }

    if (this.currentUrl.includes('/home') && !this.currentUrl.includes('/logged') && scrollTop < 200) {
      document.getElementById('header-sec').classList.add('header-transparent');
    } else {
    //  document.getElementById('header-sec').classList.remove('header-transparent');
    }
  }
}
